<landing-ad-hero-base [titleText]="titleText" [messageText]="messageText"></landing-ad-hero-base>
